var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArabicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 0H3.33333C2.44928 0 1.60143 0.495797 0.976311 1.37832C0.35119 2.26085 0 3.4578 0 4.70588L0 10H30V4.70588C30 3.4578 29.6488 2.26085 29.0237 1.37832C28.3986 0.495797 27.5507 0 26.6667 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.2941C0 26.5422 0.35119 27.7392 0.976311 28.6217C1.60143 29.5042 2.44928 30 3.33333 30H26.6667C27.5507 30 28.3986 29.5042 29.0237 28.6217C29.6488 27.7392 30 26.5422 30 25.2941V20H0V25.2941Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H30V20H0V10Z",
    fill: "#007A3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55885 1C1.069 1.43294 0.676727 1.96501 0.407989 2.56097C0.139251 3.15693 0.000185 3.80318 0 4.45692L0 25.2262C0 26.6027 0.602308 27.8385 1.55885 28.6842L20.1923 14.8415L1.55885 1Z",
    fill: "#CE1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArabicIcon);
export default __webpack_public_path__ + "static/media/ArabicIcon.c42646cadf0637261a7393717105ab05.svg";
export { ForwardRef as ReactComponent };